import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";

import { packingListStatusLink } from "../../../../core/apiLink";
import { getHeaderHelper } from "../../../../core/helpers/getHeader.helper";
import type { IRejected } from "../../../../features/claimCases/store/table/tableStore";
import type { ISellerStatusName, ISellerStatusValue } from "@/core/helpers/enum.helper";
// 从全局文件导入合并后的类型
import type { ApiRefundsServiceInfo as GlobalApiRefundsServiceInfo } from "../../../../requests/refundsServiceInfo";

export namespace ApiRefundsServiceInfo {
  export type Status = ISellerStatusName;
  export type StatusValue = ISellerStatusValue;

  // 从全局文件导入 ISeller 类型
  export type ISeller = GlobalApiRefundsServiceInfo.ISeller;
  export interface IConnection extends ISeller {
    sellerId: string;
    sellerAccount: string;
    enable: boolean;
    fullService?: boolean;
    status: Status;
    statusValue: StatusValue;
    region: string;
    lackOfPermissions: IPermission[];
    spnFlow: boolean;
    lackAwdPermission: boolean; // 控制AWD显示,true && statusValue == 4 代表要显示 AWD Access Required 标识
    allPermissions: IPermission[];
    tokenDataIsActive?: boolean;
    spnClientName?: string;
    authorizedRemovalTime?: string;
  }
  interface IRequest extends StringifiableRecord {
    sellerId?: string;
  }
  export interface IInboundResponse extends IRejected {
    data: IConnection[];
    success: string;
  }

  // 从全局文件导入 IPermission 类型
  export type IPermission = GlobalApiRefundsServiceInfo.IPermission;

  // 从全局文件导入 IServiceInfo 类型
  export type IServiceInfo = GlobalApiRefundsServiceInfo.IServiceInfo;

  interface IUpdateRequest extends IRequest {
    enable?: boolean;
  }

  export interface IUpdateResponse extends IRejected {
    success: string;
  }

  export const getInbound = (params: IRequest) =>
    baseFetch<IRequest, IInboundResponse>({
      url: getUrlWithSearchParams(packingListStatusLink, params),
      method: "GET",
      useSessionAccountId: true,
    });

  export const updateStatus = (params: IUpdateRequest) =>
    baseFetch<IRequest, IUpdateResponse>({
      url: getUrlWithSearchParams(packingListStatusLink, params),
      method: "PUT",
      headers: getHeaderHelper(),
      withCredentials: true,
      useSessionAccountId: true,
    });
}
